import store from "store2"

import header from './header/header'
import center from './center/center'
import footer from './footer/footer'
import shortcuts from './shortcuts/shortcuts'

export default function(o, done){

  var lang = o.store('lang')

  var lastInteractionAt = new Date()
  var videoReady = false
  var nextMarkerTimer = null
  var tagSlug = _.last(location.pathname.split('/'))

  var getData = function(done){
    if(tagSlug == 'random'){
      o.data.fullSequence(o, done)
    } else {
      o.data.sequence(o, tagSlug, done)
    }
  }

  getData(function(sequenceData){

    if(o.store(`nextMarkerIndex_${tagSlug}`)){
      var startIndex = o.store(`nextMarkerIndex_${tagSlug}`)
    } else {
      var startIndex = 1
    }

    if(startIndex > sequenceData.markers.length - 1){
      startIndex = 1
    }

    var currentMarker = sequenceData.markers[startIndex]
    var tagName = currentMarker[lang]

    document.title = `Open Memory Box | ${tagName}`

    var videoFile = sequenceData.files[MaxResolution]
    var videoUrl = o.util.getUrl('sequence',MaxResolution) + videoFile

    var onTimeUpdate = function(currentTime){

      if(!videoDiv[0].paused){
        var now = new Date()
        if(now - lastInteractionAt > o.autoHideTime){
          headerDiv.hide()
          centerDiv.hide()
          footerDiv.hide()
        }  
      }

      var progress = currentTime / videoDiv[0].duration
      timelineDiv.update(progress)

      var nextMarkerIn = currentTime % 2
      var nextMarkerIndex = Math.floor(currentTime / 2)
      var nextMarker = sequenceData.markers[nextMarkerIndex]

      if(!nextMarkerTimer && nextMarkerIn < 0.5){
        nextMarkerTimer =
          setTimeout(function(){
            o.store(`nextMarkerIndex_${tagSlug}`, nextMarkerIndex)
            footerDiv.setCurrentMarker(nextMarker)
            centerDiv.setCurrentMarker(nextMarker)
            if(tagSlug == 'random'){
              headerDiv.setTag(nextMarker)
            }
            currentMarker = nextMarker
            nextMarkerTimer = null
          }, nextMarkerIn * 1000)
      }

      var markerStart = o.util.smpteToSeconds(currentMarker.start)
      var markerTime = currentTime - nextMarkerIndex * 2 + markerStart
      footerDiv.updateTimecode(markerTime)

      if(!videoReady){
        shortcuts(footerDiv)
        lastInteractionAt = new Date()
        videoReady = true
        done(div)
        footerDiv.setCurrentMarker(currentMarker)
        centerDiv.setCurrentMarker(currentMarker)
        if(tagSlug == 'random'){
          headerDiv.setTag(currentMarker)
        }
      }

    }

    var onTimeChange = function(progress){
      var currentTime = progress * videoDiv[0].duration
      videoDiv[0].currentTime = currentTime
    }

    var onTogglePlay = function(isPlaying){
      o.sequenceIsPlaying = isPlaying
      lastInteractionAt = new Date()
      if(isPlaying){
        if(!o.store('soundOff')){
          o.util.soundPlay(o,0)
        }
        videoDiv[0].play()
        centerDiv.hide()
        headerDiv.hide()
        footerDiv.hide()  
      } else {
        if(!o.store('soundOff')){
          o.util.soundStop(o,0)
        }
        videoDiv[0].pause()
        centerDiv.show()
        headerDiv.show()
        footerDiv.show()  
      }
    }

    o.sequenceIsPlaying = true

    if(o.sounds.main.sound.paused){
      var s = o.sounds.main
      s.sound.currentTime = _.random(s.sound.duration)
      o.store('soundOff',true)
    }

    var headerDiv = header(o, currentMarker)
    var footerDiv = footer(o, onTogglePlay)
    var centerDiv = center(o)

    var timelineDiv = o.component.timeline(o, onTimeChange)
    .css({
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 2,
    })

    var videoDiv = o.component.video(o, videoUrl, onTimeUpdate)

    videoDiv
    .click(function(){
      lastInteractionAt = new Date()
      footerDiv.togglePlay()
    })

    videoDiv[0].muted = true

    var seekVideo = function() {
      console.log('seek video')
      videoDiv[0].removeEventListener('canplaythrough', seekVideo)
      var startTime = (startIndex - 1) * 2
      console.log('startTime', startTime)
      if(startTime == 0){startTime = 0.1}// ipad mini hack
      videoDiv[0].currentTime = startTime
      var showVideo = function(){
        videoDiv.show()
        videoDiv[0].play()
        if(videoDiv[0].paused){footerDiv.togglePlay()}// ipad mini hack
        videoDiv[0].removeEventListener('timeupdate', showVideo)
      }
      videoDiv[0].addEventListener('timeupdate', showVideo, false)
    }

    if(startIndex > 0){
      videoDiv[0].addEventListener('canplaythrough', seekVideo, false)
      videoDiv.hide()
    } else {
      videoDiv[0].play()
    }

    var toggleHideText = function(){
      lastInteractionAt = new Date()
      headerDiv.show()
      footerDiv.show()
      centerDiv.show()
    }

    o.body.on('touchstart mousemove', toggleHideText)

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      videoDiv
      .css({
        position: 'fixed',
        objectFit: 'cover',
        overflow: 'hidden',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        cursor: 'pointer',
      }),

      headerDiv
      .css({
        flex: '0 1 auto',
        width: '100%',
        justifyContent: 'center',
        textAlign: 'center',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
        pointerEvents: 'none',
      }),

      centerDiv
      .css({
        flex: '0 0 auto',
        padding: '1rem',
        width: '100%',
        minHeight: 0,
        zIndex: 1,
        pointerEvents: 'none',
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
        pointerEvents: 'none',
      }),

      footerDiv
      .css({
        flex: '0 1 auto',
        width: '100%',
        justifyContent: 'center',
        textAlign: 'center',
        minHeight: 0,
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '0 0 auto',
        height: '10px',
      }),

      timelineDiv,

    ])

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/antiArchiveTag/antiArchiveTag.js